import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'common/image/Image';
import Link from 'router/Link';
import isEmpty from 'lodash/isEmpty';

export default class Promo extends PureComponent {
    static propTypes = {
        orientation: PropTypes.oneOf(['horizontal', 'vertical']),
        imageId: PropTypes.string.isRequired,
        imagePosition: PropTypes.oneOf([
            'badge',
            'left',
            'top',
            'full',
            'right',
        ]),
        title: PropTypes.string,
        content: PropTypes.string,
        buttonText: PropTypes.string,
        buttonLink: PropTypes.string,
        links: PropTypes.arrayOf(
            PropTypes.shape({
                url: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
                action: PropTypes.string.isRequired,
            })
        ),
    };
    static defaultProps = {
        orientation: 'horizontal',
        imagePosition: 'badge',
        links: [],
    };

    constructor(props) {
        super(props);

        const {orientation, imagePosition} = props;

        switch (imagePosition) {
            default:
            case 'badge':
                this._imageWidth = 120;
                this._imageHeight = 120;

                break;

            case 'left':
            case 'right':
                this._imageWidth = 448;
                this._imageHeight = 448;

                break;

            case 'top':
                this._imageWidth = 300;
                this._imageHeight = 150;

                break;

            case 'full':
                if (orientation === 'horizontal') {
                    this._imageWidth = 465;
                    this._imageHeight = 230;
                } else {
                    this._imageWidth = 300;
                    this._imageHeight = 400;
                }

                break;
        }
    }

    _renderImage() {
        const {imagePosition, imageId} = this.props;

        return (
            <div
                className={`Promo-image-container Promo-image-container-${imagePosition}`}
            >
                <Image
                    className={`Promo-image Promo-image-${imagePosition}`}
                    width={this._imageWidth}
                    height={this._imageHeight}
                    cloudinaryImageId={imageId}
                    quality={95}
                    lazyLoad
                />
            </div>
        );
    }

    _renderPromoLinks(links) {
        return links.map(({url, description, action}, index) => (
            <div key={index} className="Promo-links">
                <Link to={url} className="Promo-link-description">
                    {description}
                </Link>
                <Link to={url} className="Promo-link-action">
                    {action}
                </Link>
            </div>
        ));
    }

    render() {
        const {
            orientation,
            imagePosition,
            title,
            content,
            buttonText,
            buttonLink,
            links,
        } = this.props;
        const classes = classNames('Promo', `Promo-${orientation}`, {
            'Promo-reverse': imagePosition === 'right',
        });
        const promoButtonClasses = classNames(
            'Promo-content-button',
            'Button',
            `Button-${orientation === 'horizontal' ? 'primary' : 'secondary'}`
        );
        const hasLinks = !isEmpty(links);

        return (
            <div className={classes}>
                {imagePosition === 'full' && buttonLink ? (
                    <Link to={buttonLink}>{this._renderImage()}</Link>
                ) : (
                    this._renderImage()
                )}
                {imagePosition !== 'full' &&
                    (title ||
                        content ||
                        (buttonText && buttonLink) ||
                        hasLinks) && (
                        <div className="Promo-content">
                            {title && (
                                <h2 className="Promo-content-title">{title}</h2>
                            )}
                            {content && <p>{content}</p>}
                            {hasLinks && this._renderPromoLinks(links)}
                            {buttonText && buttonLink && (
                                <Link
                                    to={buttonLink}
                                    className={promoButtonClasses}
                                >
                                    {buttonText}
                                </Link>
                            )}
                        </div>
                    )}
            </div>
        );
    }
}
